<div class="aggregate">
    <mode-filler-buster [token]="token" [fontSizeMax]="maxFontSize || 48" [fontSizeMin]="0" [fontName]="font"
        [content]="formattedValue">
    </mode-filler-buster>
</div>
<div class="trend-with-palette trend-{{trendDirectionClass}}" [ngStyle]="{'color': trendColorCss}" *ngIf="hasTrend">
    <span class="trend-direction-icon" [ngStyle]="trendArrowStyle"></span>
    <span class="trend-value">{{formattedChangeRate}}</span>
    <span class="trend-label">{{trendLabel}}</span>
</div>